import { SET_NOTIFICATIONS } from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  notify: [],
  tracking_platforms: null,
  ad_platforms: null,
};

const Notifications = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS: {
      return {
        ...state,
        notify: action.payload,
      };
    }
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Notifications;
